export const analyticsConfig = {
    measurementId: 'G-S7VTLPGHSF'  // Replace with your actual GA4 Measurement ID
  };